<?php

\Core\View::$template = function() {

    $greeting = '';
    $user_logged = \ISOPHP\core::$registry->getValue('user_logged') ;
    if (isset($user_logged['user']) && $user_logged['user']['full_name'] !== '') {
        \ISOPHP\js_core::$console->log('home summary user full name') ;
        $moniker = $user_logged['user']['full_name'] ;
        $greeting = '<span>Hello, <strong>'.$moniker.'</strong></span>';
    } else {
        \ISOPHP\js_core::$console->log('home summary moniker zero') ;
        //$moniker = \ISOPHP\core::$registry->getValue('user_logged')['user']->id ;
        $moniker = '' ;
        $greeting = '<h1>Hi, <strong>there</strong></h1>';
    }

    $html = '
        <link rel="stylesheet" type="text/css" href="' . CSS_ASSET_PREFIX . 'app/HomeSummary/Assets/css/default.css">
        <header class="col-sm-12 navbar">
            <div class="col-sm-2">            
                <img class="nav_logo" src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/logg.png" height="80" />
            </div>
            <div class="col-sm-8">
                '. $greeting .'
                <h2>Jobs @ Video Interviews</h2> 
            </div>
            <div class="col-sm-2">
                <div id="user-menu-button" class="menu-button user-menu-button">
                    <!--<div id="user_menu_entries" class="menu_entries user_menu_entries">
                        <div class="menu_entry">
                            <span id="user_menu_link_job_list">Job List</span>
                        </div>
                    </div>-->
                </div>
                <div id="user-menu-button" class="menu-button user-menu-button"></div>
                <div id="settings-menu-button" class="menu-button settings-menu-button"></div>
            </div>
        </header>  ';

    $html = $html . '
        <div class="col-sm-12">
            <div class="latest">
                <h4>Latest Login</h4>
                <h5 id="latest-login-date">&nbsp;</h5>
                <h5 id="latest-login-time">&nbsp;</h5>
            </div> 
            <hr>
        </div>  ';

    $html = $html . '
        <div class="col-sm-12" id="home_summary_accounts">Job list for logged user loading..</div>';


    $html = $html . '    <div class="col-sm-12">' ;
    $html = $html . '        <span id="go-jobs-list" class="btn btn-warning">Job List</span>' ;
    $html = $html . '    </div>' ;
    $html = $html . '</form>' ;

    return $html ;

} ;


// WEBPACK FOOTER //
// app/JobList/View/JobListForUser.php